import { SearchQueue } from 'lib-search-types';
import { useEffect, useRef } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { WrappedFieldProps } from 'redux-form';

import { HookFormSearchSelect } from 'components/hookForm/hookFormSearchSelect';

type ComposeEmailQueueSelectFieldFormValues = {
  queue: SearchQueue[];
};

type ComposeEmailQueueSelectFieldProps = WrappedFieldProps;

export const ComposeEmailQueueSelectField = (
  props: ComposeEmailQueueSelectFieldProps,
): JSX.Element => {
  const { input } = props;
  const selectedQueue: SearchQueue | null = input.value || null;

  const form = useForm<ComposeEmailQueueSelectFieldFormValues>({
    mode: 'all',
    defaultValues: {
      queue: selectedQueue ? [selectedQueue] : [],
    },
  });

  const queue = useWatch({ control: form.control, name: 'queue' });
  const prevQueueRef = useRef(queue);

  useEffect(() => {
    const prev = prevQueueRef.current;
    prevQueueRef.current = queue;

    const newQueue = queue?.[0];
    const prevQueue = prev?.[0];

    if (newQueue?.id === prevQueue?.id) return;

    input.onChange(newQueue ?? null);
  }, [queue, input]);

  return (
    <HookFormSearchSelect
      name="queue"
      control={form.control}
      scope="queues"
      initialArg={{
        sortBy: { field: 'name', order: 'asc' },
        filters: {
          strategy: 'all',
          filters: [
            {
              field: 'is_archived',
              operator: 'not_equals',
              values: [{ value: 'true' }],
            },
          ],
        },
      }}
      renderSelectionListItemContent={(queue) => queue.name}
      componentProps={{
        clearable: true,
        placeholder: 'Select a queue',
        equalityFn: (a, b) => a?.id === b?.id,
        getItemTitleByValue: (queue) => queue?.name ?? '',
      }}
    />
  );
};
